import { Component, ViewChild, TemplateRef, Input, ElementRef, AfterViewInit, OnInit, OnChanges } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { qmsService } from '../qms.service';
import { TasksEcComponent } from '../../qms/tasks-ec/tasks-ec.component';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { DocumentViewerComponent } from 'src/app/support/document-viewer/document-viewer.component';
import { DocViewerConfig } from 'src/app/support/models/doc-viewer-config.model';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-tasks-ec-documents',
  templateUrl: './tasks-ec-documents.component.html',
  styleUrls: ['./tasks-ec-documents.component.scss']
})

export class TasksEcDocumentsComponent implements AfterViewInit, OnInit, OnChanges {

  @Input() effectivenessCheckData: any = {};
  @Input() refresh: boolean;
  isProcessing = false;
  module: any;
  refNo: any;
  loggedUserId: any;
  constructor(public dialog: MatDialog, public appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef, public qmsservice: qmsService, public tasksEcComponent: TasksEcComponent) {
    this.module = this.qmsservice.moduleName;
    this.refNo = this.message.ecMasterDetails.REF_NO;
    this.loggedUserId = this.message.getUserId();
  }

  dropDownDataForDocumentType: any = [];
  getQmsTaskECActionsVwDetails: any = [];
  dropDownForActionName: any = [];
  addDocumentPriv: boolean;
  actionSearchText: string = '';
  docTypeSearchText: string = ''; isFrozen: boolean = false;

  findingsList: any = [];
  findingsDropdown: any = [];
  findingSearchText: any = [];

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  ngAfterViewInit() {
    const status = this.effectivenessCheckData.status;
    const isQa = this.effectivenessCheckData.qaApprovedBy === +this.message.getUserId();
    const isApprover = this.effectivenessCheckData.approvedBy === +this.message.getUserId();

    if (status == "Pending QA Approval") {
      this.isFrozen = !isQa;
    } else if (status == "Pending Approval") {
      this.isFrozen = !isApprover;
    } else {
      this.isFrozen = this.effectivenessCheckData.showSubTaskButtons;
    }
  }

  ngOnInit() {
    this.addDocumentPriv = false;
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("DOCUMENT_TYPE").subscribe((data: any) => {
      this.dropDownDataForDocumentType = data;
      this.selectBoxForDocumentType();
    })

    if (this.message.ecMasterDetails.CHECK_REQD_FOR == "Individual Action Items") {
      this.appService.getQmsTaskEcActionVwDetails(this.refNo, this.message.ecMasterDetails.EC_ID).subscribe((data: any) => {
        this.getQmsTaskECActionsVwDetails = data;
        if (this.getQmsTaskECActionsVwDetails.length > 0) {
          this.getQmsTaskECActionsVwDetails.forEach((actionData: any = []) => {
            if (!this.dropDownForActionName.some((tempData: any = []) => tempData.actionName === actionData.actionName)) {
              this.dropDownForActionName.push(actionData);
            }
            this.selectBoxForActionName();
          });
        }
        this.isProcessing = false;
      });
      this.showActionDropdown = true;
    } else if (this.message.ecMasterDetails.CHECK_REQD_FOR == "Individual Findings") {
      this.appService.getAllAuFindingsByAuNo(this.refNo).subscribe((findings: any) => {
        this.findingsList = findings;
        this.isProcessing = false;
        this.selectBoxForFindings();
      });
      this.showActionDropdown = false;
    } else {
      this.showActionDropdown = false;
    }

    this.getcallMethod();
    this.ngOnChanges();
    this.appService.getOneQmsOrganization().subscribe((data: any) => {
      this.orgData = data;
    })
  }

  orgData: any;
  ngOnChanges() {
    if (this.effectivenessCheckData.status == 'In Progress' || this.effectivenessCheckData.status == 'Planning' ||
      this.effectivenessCheckData.status == 'Approval Rejected' || this.effectivenessCheckData.status == 'QA Approval Rejected' ||
      this.effectivenessCheckData.status == 'QA Approved') {
      this.addDocumentPriv = this.qmsservice.userRole[0].qmsRoles.includes("Effectiveness Check Performer");
    } else if (this.effectivenessCheckData.status == 'Pending Approval') {
      this.addDocumentPriv = this.qmsservice.userRole[0].qmsRoles.includes("Effectiveness Check Approver");
    } else if (this.effectivenessCheckData.status == 'Pending QA Approval') {
      this.addDocumentPriv = this.qmsservice.userRole[0].qmsRoles.includes("QA");
    } else {
      this.addDocumentPriv = false;
    }

    this.tasksEcComponent.getEcFieldDisabledConditions();
    this.refresh = false;
  }

  refreshForm() {
    this.getcallMethod();
  }

  public selectBoxForFindings(): void {
    this.findingsDropdown = this.findingsList?.map((finding: any) => ({
      valueExp: finding.findingId,
      displayExp: finding.findingShortDescription
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  public onFindingSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.handleDropDownValidation('finding', item.valueExp);
      })
    }
  }

  public handleDropDownValidation(fieldId: string, selectedItems: any[] | string): void {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = fieldId == 'business-area';
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  qmsTasksECDetailsDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.qmsTasksECDetailsDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.qmsTasksECDetailsDataForGrid
      .slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }


  getcallMethod() {
    this.qmsTasksECDetailsDataForGrid = [];

    const data = {

      gridName: "EC_DOCUMENT",
      groupId: 0
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "QMS_TASK_EC_DOCUMENTS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: (response.invisibleColumn ?? '') + (this.qmsservice.moduleName == 'AU' ? ",ACTION_NAME" : ",FINDING_SHORT_DESCRIPTION"),
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          refNoFromEffectivenessCheckDetail: this.refNo,
          ecIdFromECMasterPage: this.message.ecMasterDetails.EC_ID,
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.qmsTasksECDetailsDataForGrid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const element of this.qmsTasksECDetailsDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    element[dataType.columnName] = element[dataType.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.labelcall();
              this.setPage(1, 0);
            });
            this.message.gridList = this.qmsTasksECDetailsDataForGrid;
            this.collectionSize = this.qmsTasksECDetailsDataForGrid.length;
            this.totalPages = Math.ceil(this.qmsTasksECDetailsDataForGrid.length / this.itemsPerPage);
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.dynamicLabel = null;
    this.label = [];
    this.dynamicLabel = null;
    let data = {
      gridName: this.reportObj.gridName,
      tableName: this.reportObj.tableOrViewName,
      moduleName: this.qmsservice.moduleName,
      groupId: this.qmsservice.selectedGroup,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        return this.dynamicLabel
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.qmsTasksECDetailsDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.qmsTasksECDetailsDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.qmsTasksECDetailsDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.qmsTasksECDetailsDataForGrid) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const element of this.qmsTasksECDetailsDataForGrid) {
        element.childCheckBoxs = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.qmsTasksECDetailsDataForGrid[this.previousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
    this.previousSelectedValue = idx;
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
  };

  selectedDocumentType: any;
  documentTypeListDropdown: any = [];

  selectBoxForDocumentType() {
    this.documentTypeListDropdown = [];
    for (const element of this.dropDownDataForDocumentType) {
      this.documentTypeListDropdown = this.documentTypeListDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }

  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;

  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  selectedActionName: any;
  actionNameListDropdown: any = [];
  selectBoxForActionName() {
    this.actionNameListDropdown = [];
    for (const element of this.dropDownForActionName) {
      this.actionNameListDropdown = this.actionNameListDropdown.concat({
        valueExp: element.actionId,
        displayExp: element.actionName
      });
    }
  }

  onActionSelect(item: any) {

    if (this.actionNameRequired != undefined) {
      this.actionNameRequired.style.color = '';
    }
  }

  onActionsRemoved(item: any) {
    if (this.actionNameRequired != undefined) {
      this.actionNameRequired.style.color = 'red';
    }
  }

  onDocumentTypeSelect(item: any) {

    if (this.documentTypeValueRequired != undefined) {
      this.documentTypeValueRequired.style.color = '';
    }
  }

  onDocumentTypeRemoved(item: any) {
    if (this.documentTypeValueRequired != undefined) {
      this.documentTypeValueRequired.style.color = 'red';
    }
  }

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  operationFlag: any;
  ecDocumentData: any = {};
  showActionDropdown: boolean = false;
  openAddPopup() {
    this.popupDataTitle.title = "Add Effectiveness Check Document";
    this.operationFlag = 'ADD';
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.selectedActionName = null;
    this.selectedDocumentType = null;
    this.ecDocumentData.documentName = "";
    this.documentToUpload = null;
    if (this.message.ecMasterDetails.CHECK_REQD_FOR == "Individual Action Items") {
      this.appService.getQmsTaskEcActionVwDetails(this.refNo, this.message.ecMasterDetails.EC_ID).subscribe((data: any) => {
        this.getQmsTaskECActionsVwDetails = data;
        if (this.getQmsTaskECActionsVwDetails.length > 0) {
          this.getQmsTaskECActionsVwDetails.forEach((actionData: any = []) => {
            if (!this.dropDownForActionName.some((tempData: any = []) => tempData.actionName === actionData.actionName)) {
              this.dropDownForActionName.push(actionData);
            }
            this.selectBoxForActionName();
          });
        }
        this.showActionDropdown = true;
        this.isProcessing = false;
      });
    } else {
      this.showActionDropdown = false;
    }
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  editingData: any;
  getQmsTaskEcDocumentsVwDetailsData: any = [];
  filteredActionValue: any = [];
  filteredDocumentTypeValue: any = [];
  previouslyUploadedDocument: any
  previouslyUploadedDocumentName: any;
  openEditPopup(ecDetailsEditingData: any) {
    this.isProcessing = true;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Edit Effectiveness Check Document";
    this.previouslyUploadedDocument = '';
    this.editingData = ecDetailsEditingData;
    this.appService.getQmsTaskEcDocumentsVwDetailsByOrgIdAndRefNoAndEcIdAndDocumentId(this.refNo, this.editingData.EC_ID, this.editingData.DOCUMENT_ID).subscribe((response: any) => {
      this.getQmsTaskEcDocumentsVwDetailsData = response;
      this.ecDocumentData.documentName = this.getQmsTaskEcDocumentsVwDetailsData.documentName;

      if (this.getQmsTaskEcDocumentsVwDetailsData.actionId) {
        this.showActionDropdown = true;
        this.filteredActionValue = this.dropDownForActionName.filter((x: any) => x.actionId === this.getQmsTaskEcDocumentsVwDetailsData.actionId);
        if (this.filteredActionValue.length > 0) {
          this.selectedActionName = this.filteredActionValue[0].actionId;
          /*     this.selectedActionName = [{
                valueExp: this.filteredActionValue[0].actionId,
                displayExp: this.filteredActionValue[0].actionName
              }] */
        }
      } else {
        this.showActionDropdown = false;
        this.selectedActionName = null;
      }

      if (this.getQmsTaskEcDocumentsVwDetailsData.documentType != null) {
        this.filteredDocumentTypeValue = this.dropDownDataForDocumentType.filter((x: any) => x.codelistCode === this.getQmsTaskEcDocumentsVwDetailsData.documentType);
        if (this.filteredDocumentTypeValue.length > 0) {
          /*   this.selectedDocumentType = [{
              valueExp: this.filteredDocumentTypeValue[0].codelistCode,
              displayExp: this.filteredDocumentTypeValue[0].codelistName
            }] */
          this.selectedDocumentType = this.filteredDocumentTypeValue[0].codelistCode;
        } else {
          /*     this.selectedDocumentType = [{
                valueExp: this.getQmsTaskEcDocumentsVwDetailsData.documentType,
                displayExp: this.getQmsTaskEcDocumentsVwDetailsData.documentType
              }] */
          this.selectedDocumentType = this.getQmsTaskEcDocumentsVwDetailsData.documentType;

        }
      }
      if (this.getQmsTaskEcDocumentsVwDetailsData.documentBlob != null) {
        this.previouslyUploadedDocumentName = this.getQmsTaskEcDocumentsVwDetailsData.documentName;
        this.previouslyUploadedDocument = this.getQmsTaskEcDocumentsVwDetailsData.documentBlob;
        this.documentsExtention = this.getQmsTaskEcDocumentsVwDetailsData.documentExtn;
      }

      this.documentToUpload = null;
      this.isProcessing = false;
      this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    })
  }

  deletingData: any
  openDeletePopup(ecDetailsDeletingData: any) {
    this.deletingData = ecDetailsDeletingData;
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Effectiveness Check Document";
    this.ecDocumentData.deleteReason = "";
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  cancelAddAndEditPopup() {
    this.visibleAddAndEditPopup.close();
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  uploadSuccessMsg: any;
  uploadSuccessIcon: any;
  documentToUpload: File | null = null;
  documentsExtention: any;
  preDocumentValidation: any;
  chooseDocument(e: any) {
    this.documentToUpload = e.target.files[0];
    this.documentsExtention = (e.target.files[0].name.split('.').pop() ?? '').toLowerCase();
    const file: File = e.target.files[0];
    this.ecDocumentData.documentName = file.name.substring(0, file.name.lastIndexOf('.'))

    this.uploadSuccessMsg = document.getElementById('template-success-msg') as HTMLInputElement;
    this.uploadSuccessIcon = document.getElementById('template-success-icon') as HTMLInputElement;
    this.documentUploadRequired = document.getElementById("documentUpload") as HTMLInputElement;
    this.preDocumentValidation = document.getElementById('preDocument-validation') as HTMLInputElement;

    if (this.documentToUpload) {
      this.uploadSuccessMsg.style.display = 'block';
      this.uploadSuccessIcon.style.display = 'block';
      if (this.documentToUpload != null && this.visibleEditButton) {
        this.preDocumentValidation.style.display = 'none';
      }
    } else {
      this.uploadSuccessMsg.style.display = 'none';
      this.uploadSuccessIcon.style.display = 'none';
    }

    if (this.documentUploadRequired != undefined) {
      if (this.documentToUpload == null) {
        this.documentUploadRequired.style.color = 'red';
      } else {
        this.documentUploadRequired.style.color = '';
      }
    }

  }

  actionNameRequired: any;
  documentTypeValueRequired: any;
  documentNameValueRequired: any;
  documentUploadRequired: any;
  fieldValidation() {
    this.actionNameRequired = document.getElementById("actionName") as HTMLInputElement;
    this.documentTypeValueRequired = document.getElementById("documentType") as HTMLInputElement;
    this.documentNameValueRequired = document.getElementById("documentName") as HTMLInputElement;
    this.documentUploadRequired = document.getElementById("documentUpload") as HTMLInputElement;

    if (this.message.ecMasterDetails.CHECK_REQD_FOR == "Individual Action Items") {
      if (this.selectedActionName) {
        this.actionNameRequired.style.color = '';
      } else {
        this.actionNameRequired.style.color = 'red';
      }
    }

    if (this.selectedDocumentType) {
      this.documentTypeValueRequired.style.color = '';
    } else {
      this.documentTypeValueRequired.style.color = 'red';
    }

    if (this.ecDocumentData.documentName) {
      this.documentNameValueRequired.style.color = '';
    } else {
      this.documentNameValueRequired.style.color = 'red';
    }

    if (this.documentToUpload == null) {
      this.documentUploadRequired.style.color = 'red';
    } else {
      this.documentUploadRequired.style.color = '';
    }

  }

  onFieldFocusout() {
    if (this.documentNameValueRequired != undefined) {
      if (this.ecDocumentData.documentName == "" || this.ecDocumentData.documentName == undefined) {
        this.documentNameValueRequired.style.color = 'red';
      } else {
        this.documentNameValueRequired.style.color = '';
      }
    }
  }

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  documentParams: any = {};
  documentByteValue: any;
  addAndEditFunction(ecDocumentData: any) {
    let list = [];
    if (this.orgData.allowedFileExtns) {
      list = this.orgData.allowedFileExtns.split(",");

    };
    if ((!list.includes(this.documentsExtention?.toUpperCase())) && this.documentsExtention) {
      this.showSnackBar("File extension " + this.documentsExtention + " is not allowed.", "E");
      this.isProcessing = false;
    }
    else
      if ((this.message.ecMasterDetails.CHECK_REQD_FOR == "Individual Action Items" && (!this.selectedActionName)) ||
        !this.selectedDocumentType || !this.ecDocumentData.documentName) {
        alert('Please enter the all mandatory fields...');
        this.fieldValidation();
      } else if (this.operationFlag == "ADD") {
        this.isProcessing = true;
        if (this.selectedActionName) {
          this.ecDocumentData.actionId = this.selectedActionName;
        } else {
          this.ecDocumentData.actionId = undefined;
        }

        if (this.selectedDocumentType) {
          this.ecDocumentData.documentType = this.selectedDocumentType;
        } else {
          this.ecDocumentData.documentType = undefined;
        }

        this.documentParams = {
          ecId: this.message.ecMasterDetails.EC_ID,
          module: this.module,
          refNo: this.refNo,
          actionId: this.ecDocumentData.actionId,
          documentType: this.ecDocumentData.documentType,
          documentName: this.ecDocumentData.documentName,
          documentExtn: this.documentsExtention,
          findingId: this.message.ecMasterDetails.CHECK_REQD_FOR == 'Individual Findings' ? this.ecDocumentData.findingId : null,
        }
        console.log(this.documentParams);
        const json = JSON.stringify(this.documentParams);
        const blob = new Blob([json], {
          type: 'application/json'
        })
        const addEcDocumentsData = new FormData();
        addEcDocumentsData.append('ecDocument', this.documentToUpload ?? '');
        addEcDocumentsData.append('qmsTaskECDocumentsVwDto', blob);
        this.appService.createQmsTasksECDocuments(addEcDocumentsData).subscribe({
          next: (Response: any) => {
            this.displayMessage = Response.result;
            this.displayResultType = Response.resultType;
            if (this.displayResultType == 'S') {
              this.visibleAddAndEditPopup.close();
              this.getcallMethod();
              this.ngOnChanges();
            }
            this.isProcessing = false;
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: this.displayResultType == 'S' ? 5000 : undefined,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok",
                pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {

        delete ecDocumentData.createdOn;
        delete ecDocumentData.updatedOn;

        if (this.selectedActionName) {
          this.ecDocumentData.actionId = this.selectedActionName;
        } else {
          this.ecDocumentData.actionId = null;
        }

        if (this.selectedDocumentType) {
          this.ecDocumentData.documentType = this.selectedDocumentType;
        } else {
          this.ecDocumentData.documentType = null;
        }

        if (this.documentToUpload == null) {
          this.documentByteValue = this.previouslyUploadedDocument;
        } else {
          this.documentByteValue = null;
        }

        this.documentParams = {
          qmsTaskECDocumentsVwPk: {
            documentId: this.editingData.DOCUMENT_ID,
          },
          ecId: this.message.ecMasterDetails.EC_ID,
          module: this.module,
          refNo: this.refNo,
          actionId: this.ecDocumentData.actionId,
          documentType: this.ecDocumentData.documentType,
          documentName: this.ecDocumentData.documentName,
          documentExtn: this.documentsExtention,
          documentBlob: this.documentByteValue,
          findingId: this.message.ecMasterDetails.CHECK_REQD_FOR == 'Individual Findings' ? this.ecDocumentData.findingId : null,
        }
        const json = JSON.stringify(this.documentParams);
        const blob = new Blob([json], {
          type: 'application/json'
        })
        const addEcDocumentsData = new FormData();
        addEcDocumentsData.append('ecDocument', this.documentToUpload ?? '');
        addEcDocumentsData.append('qmsTaskECDocumentsVwDto', blob);
        this.appService.updateQmsTasksECDocuments(addEcDocumentsData).subscribe({
          next: (Response: any) => {
            this.displayMessage = Response.result;
            this.displayResultType = Response.resultType;
            if (this.displayResultType == 'S') {
              this.visibleAddAndEditPopup.close();
              this.getcallMethod();
              this.ngOnChanges();
            }
            this.isProcessing = false;
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: this.displayResultType == 'S' ? 5000 : undefined,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok",
                pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  deleteReasonValue: any;
  deleteReasonRequiredMsg: any;
  deleteValidation() {
    this.deleteReasonValue = document.getElementById('deleteReason') as HTMLInputElement;
    this.deleteReasonRequiredMsg = document.getElementById('deleteReason-required-msg') as HTMLInputElement;
    if (this.deleteReasonValue.value == '') {
      this.deleteReasonValue.style.border = '1px solid red';
      this.deleteReasonRequiredMsg.style.display = 'block';
    } else {
      this.deleteReasonValue.style.border = 'none';
      this.deleteReasonRequiredMsg.style.display = 'none';
    }
  }

  deleteFunction(ecDocumentData: any) {
    if (this.ecDocumentData.deleteReason == "") {
      this.deleteValidation();
    } else {
      this.isProcessing = true;
      let deleteDocumentData = {
        qmsTaskECDocumentsVwPk: {
          documentId: this.deletingData.DOCUMENT_ID,
        },
        ecId: this.message.ecMasterDetails.EC_ID,
        deleteReason: this.ecDocumentData.deleteReason,
      }
      this.appService.deleteQmsTasksECDocuments(deleteDocumentData).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.visibleDeletePopup.close();
            this.getcallMethod();
            this.ngOnChanges();
          }
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });

        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      })
    }
  }

  downloadEcDocument1(documentData: any) {
    console.log(document);
    let contentData = "data:application/octet-stream;base64," + documentData.DOCUMENT_BLOB;
    let downloadLink = document.createElement("a");
    downloadLink.href = contentData;
    downloadLink.download = documentData.DOCUMENT_NAME + "." + documentData.DOCUMENT_EXTN;
    downloadLink.click();
  }

  @ViewChild(DocumentViewerComponent) documentViewerComponent!: DocumentViewerComponent;
  docViewer!: DocViewerConfig;

  viewEcDocument(list: any) {
    this.isProcessing = true;

    const docObj = {
      qmsTaskECDocumentsVwPk: {
        documentId: list.DOCUMENT_ID,
      },
      ecId: list.EC_ID,
      refNo: list.REF_NO,
      documentName: list.DOCUMENT_NAME,
      documentType: list.DOCUMENT_TYPE,
      documentExtn: list.DOCUMENT_EXTN
    };

    this.appService.viewQmsEcDocument(docObj).subscribe({
      next: (response: any) => {
        if (response.status === 200) {
          try {
            const contentType = response.headers.get('content-type');
            const blob = new Blob([response.body], { type: contentType });

            const doc = {
              body: blob,
              contentType: contentType,
              extn: list.DOCUMENT_EXTN
            };

            this.docViewer = {
              blob,
              doc,
              docName: list.DOCUMENT_NAME,
              docExtension: list.DOCUMENT_EXTN
            };

            setTimeout(() => {
              this.documentViewerComponent?.openPopUp();
            }, 0);

          } catch (err) {
            console.error('Error while preparing document for view:', err);
            alert('Failed to load document.');
          }
        } else {
          alert('Error occurred while loading document: ' + response.status);
        }
        this.isProcessing = false;
      },
      error: () => {
        alert("Failed to load EC document.");
        this.isProcessing = false;
      }
    });
  }


  idMapping: Record<string, string> = { 'CR': this.qmsservice.activity.crId, 'CAPA': this.qmsservice.activity.capaId, 'DV': this.qmsservice.activity.dvId, 'AU': this.qmsservice.activity.auId, 'IN': this.qmsservice.activity.inId, 'QI': this.qmsservice.activity.qiId, 'CC': this.qmsservice.activity.ccId };


  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;
  auditTrail: any = {};

  openAuditTrail(viewType: any, extension: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : extension.DOCUMENT_ID;
    this.auditTrail.activityRefNo = this.message.activityId;
    this.auditTrail.gridName = 'EC_DOCUMENT';
    this.auditTrail.report_And_Popup_Name = this.qmsservice.moduleName + 'Effectiveness Check Documents Audit Trail [' + this.idMapping[this.qmsservice.moduleName] + ']';
    this.dynamicAuditTrailComponent.triggerTrail(extension);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = { ...this.reportObj, excludeGroupId: true };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = this.qmsservice.moduleName + ' Effectiveness Check Documents Report [' + this.idMapping[this.qmsservice.moduleName] + ']';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.filter((item: any) => item.fieldColumnarray != 'Document')?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, this.qmsservice.moduleName, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  public focusEmpty(): void { console.log() };
}
